import { defHttp } from 'xmgoing-server';

export type DataHistoryOperateType = 'INSERT' | 'UPDATE' | 'DELETE' | string;

export type DataHistoryRecord = {
  id: string;
  operateType?: DataHistoryOperateType;
  operatorName?: string;
  operateTime?: string;
  scene?: string;
  /** assemble=true 时的业务快照；assemble=false 时为 null */
  data?: Record<string, any> | null;
  [key: string]: any;
};

export type DataHistoryDetailComponent = {
  componentPageCode?: string;
  componentModuleCode?: string;
  idFieldName?: string;
  businessName?: string;
  [key: string]: any;
};

export type DataHistoryListResult = {
  total?: number;
  current?: number;
  size?: number;
  records?: DataHistoryRecord[];
  detailComponent?: DataHistoryDetailComponent | null;
};

export function listAssembled(params: {
  tableCode: string;
  bizId: string;
  current: number;
  size: number;
  assemble: boolean;
}) {
  return defHttp.get<DataHistoryListResult>(
    {
      url: '/xm-mes/dataHistory/listAssembled',
      params: {
        tableCode: params.tableCode,
        bizId: params.bizId,
        current: params.current,
        size: params.size,
        assemble: params.assemble,
      },
    },
    { errorMessageMode: 'none' },
  );
}
